<!-- 促销策略 -->
<template>
    <div class='page_content'>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" :buttonFlag="false" :showRefresh="true" @actionSet="actionSet" @getPageInfo="getDataList"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline dis" size="mini" @submit.native.prevent>
                    <el-form-item label="方案名称" class="pd">
                        <el-input class="form_codition" v-model.trim="getRequestData.promName" :maxlength="$store.state.inputLength" @keyup.enter.native="searchData" clearable placeholder="请输入方案名称"></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间" class="pd">
                        <el-date-picker class="form_codition" size="mini" v-model="getRequestData.start" format="yyyy年MM月dd日" value-format="timestamp" type="date" placeholder="选择日期" clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间" class="pd">
                        <el-date-picker class="form_codition" size="mini" v-model="getRequestData.end" @change="changeTime" format="yyyy年MM月dd日" value-format="timestamp" type="date" placeholder="选择日期" clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="pd">
                        <el-button type="primary" icon="el-icon-search" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 列表标题栏：对齐 v-tabs 主题 -->
            <div class="module_toolbar">
                <div class="module_toolbar_left">
                    <span class="report_name">促销策略</span>
                </div>
                <span class="module_count">共 {{ returnData.total || 0 }} 条</span>
            </div>
        </div>

        <div class="page_content_center" v-loading="tableLoading">
            <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row>
                <el-table-column label="选择" width="70" align="center">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini" @change="selectedDataAction">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column type="expand" label="明细" width="50">
                    <template slot-scope="props">
                        <div class="module_block">
                            <div class="module_header">
                                <span class="module_title">促销商品明细</span>
                                <span class="module_count">共 {{ (props.row.promotiondetailInfos || []).length }} 条</span>
                            </div>
                            <div class="module_body">
                                <div class="detail_toolbar">
                                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="openSonDataBox(0, props.row.promId)">新增</el-button>
                                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="openSonDataBox(1, props.row.promId)">编辑</el-button>
                                    <el-button type="danger" size="mini" icon="el-icon-delete" plain @click="delDetails()">删除</el-button>
                                </div>
                                <el-table size="mini" :data="props.row.promotiondetailInfos || []" border style="width: 100%">
                                    <el-table-column label="选择" width="70" align="center">
                                        <template slot-scope="scope">
                                            <el-radio v-model="selectedDetailsDataIndex" :label="props.$index + ',' + scope.$index" @change="selectedDetailsDataAction" border size="mini">
                                                <i class="el-icon-thumb"></i>
                                            </el-radio>
                                        </template>
                                    </el-table-column>
                                    <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                                    <el-table-column prop="saleGoodInfo.bgmName" label="商品" min-width="140" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="prodSalenum" label="商品数量" width="100" align="center"></el-table-column>
                                    <el-table-column prop="giftGoodInfo.bgmName" label="赠品" min-width="140" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="prodGiftnum" label="赠品数量" width="100" align="center"></el-table-column>
                                    <el-table-column prop="prodState" label="状态" width="90" align="center">
                                        <template slot-scope="scope">
                                            <el-tag v-if="scope.row.prodState == 0" size="mini" type="info">停用</el-tag>
                                            <el-tag v-else-if="scope.row.prodState == 1" size="mini" type="success">启用</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="prodIsaccum" label="是否累积" width="90" align="center">
                                        <template slot-scope="scope">
                                            <el-tag size="mini" :type="scope.row.prodIsaccum == 0 ? 'info' : ''">
                                                {{ scope.row.prodIsaccum == 0 ? '否' : '是' }}
                                            </el-tag>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column prop="promName" label="方案名称" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="pmState" label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.pmState == 0" size="mini" type="info">停用</el-tag>
                        <el-tag v-else-if="scope.row.pmState == 1" size="mini" type="success">启用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="promStdate" label="开始时间" width="160" align="center">
                    <template slot-scope="scope">
                        {{ $common.getLocalTime(scope.row.promStdate) }}
                    </template>
                </el-table-column>
                <el-table-column prop="promEndate" label="结束时间" width="160" align="center">
                    <template slot-scope="scope">
                        {{ $common.getLocalTime(scope.row.promEndate) }}
                    </template>
                </el-table-column>
                <el-table-column prop="promRemark" label="备注说明" min-width="160" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>

        <!-- 主数据抽屉 -->
        <el-drawer :close-on-press-escape="true" :visible.sync="dataActionBox.showStatus" :with-header="false" :append-to-body="true" custom-class="drawer_box"  direction="ltr" size="520px">
            <div class="demo-drawer__content data_action_form drawer_panel">
                <div class="drawer_header">
                    <span class="drawer_title">{{ dataActionBox.boxTitle }}</span>
                    <i class="el-icon-close drawer_close" @click="dataActionBox.showStatus = false"></i>
                </div>
                <div class="drawer_body">
                    <el-form label-width="100px" :model="sendDataInfo" size="mini" class="baseForm">
                        <el-form-item label="方案名称" required>
                            <el-input v-model.trim="sendDataInfo.promName" :maxlength="$store.state.inputLength" placeholder="请输入方案名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="开始时间" required>
                            <el-date-picker v-model="sendDataInfo.promStdate" type="date" placeholder="选择日期" format="yyyy年MM月dd日" value-format="timestamp" style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间" required>
                            <el-date-picker v-model="sendDataInfo.promEndate" type="date" placeholder="选择日期" format="yyyy年MM月dd日" value-format="timestamp" style="width: 100%;" @change="changeFormEndTime">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="策略状态">
                            <el-radio-group v-model="sendDataInfo.pmState">
                                <el-radio-button :label="0">停用</el-radio-button>
                                <el-radio-button :label="1">启用</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="备注信息">
                            <el-input type="textarea" v-model.trim="sendDataInfo.promRemark" maxlength="60" :rows="3" show-word-limit placeholder="请输入备注"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="drawer_foots">
                    <el-button @click="dataActionBox.showStatus = false">取消</el-button>
                    <el-button type="primary" :loading="submitLoading" @click="sendDataAction">保存</el-button>
                </div>
            </div>
        </el-drawer>

        <!-- 明细弹窗 -->
        <el-dialog :title="sonDataActionBox.boxTitle" :visible.sync="sonDataActionBox.showStatus" append-to-body :close-on-click-modal="false" center top="2rem" width="560px">
            <el-form label-width="100px" :model="sendSonDataInfo" size="mini" class="baseForm">
                <el-form-item label="选择商品" required>
                    <el-input v-model.trim="sendSonDataInfo.prodSaleName" maxlength="60" readonly placeholder="请选择商品" @focus="openGoodsSelect('prodSaleid')">
                        <el-button slot="append" icon="el-icon-search" @click="openGoodsSelect('prodSaleid')"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="商品数量" required>
                    <el-input-number v-model="sendSonDataInfo.prodSalenum" :min="0" :precision="0" controls-position="right" style="width: 100%;"></el-input-number>
                </el-form-item>
                <el-form-item label="选择赠品" required>
                    <el-input v-model.trim="sendSonDataInfo.prodGiftName" maxlength="60" readonly placeholder="请选择赠品" @focus="openGoodsSelect('prodGiftid')">
                        <el-button slot="append" icon="el-icon-search" @click="openGoodsSelect('prodGiftid')"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="赠品数量" required>
                    <el-input-number v-model="sendSonDataInfo.prodGiftnum" :min="0" :precision="0" controls-position="right" style="width: 100%;"></el-input-number>
                </el-form-item>
                <el-form-item label="是否累积">
                    <el-radio-group v-model="sendSonDataInfo.prodIsaccum">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                    <div class="form_tip">
                        <i class="el-icon-info"></i>
                        如果累积，则按超过卖品数量的整倍数计算赠品数量
                    </div>
                </el-form-item>
                <el-form-item label="状态">
                    <el-radio-group v-model="sendSonDataInfo.prodState">
                        <el-radio-button :label="0">停用</el-radio-button>
                        <el-radio-button :label="1">启用</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="sonDataActionBox.showStatus = false">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="sendDetailsDataAction">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        const todayStart = new Date(new Date().toLocaleDateString()).getTime()
        return {
            tableHeight: 0,
            tableLoading: false,
            submitLoading: false,
            getRequestData: {
                promName: '',
                page: 1,
                rows: 30,
                start: todayStart - 31 * 24 * 3600 * 1000,
                end: todayStart + 24 * 60 * 60 * 1000 - 1,
            },
            returnData: {
                pages: 0,
                total: 0,
                pageNum: 0,
                list: []
            },
            buttonList: [],
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr',
                boxTitle: '新增信息',
                actionType: 0,
            },
            sonDataActionBox: {
                showStatus: false,
                openMode: 'ltr',
                boxTitle: '新增信息',
                actionType: 0,
            },
            sendDataInfo: {
                pmState: 0,
                promEndate: '',
                promName: '',
                promRemark: '',
                promStdate: '',
            },
            sendSonDataInfo: {
                prodGiftid: '',
                prodGiftName: '',
                prodGiftnum: 0,
                prodIsaccum: 0,
                prodSaleid: '',
                prodSaleName: '',
                prodSalenum: 0,
                prodState: 0,
                promId: '',
                prodId: '',
            },
            selectedDataIndex: 0,
            selectedDetailsDataIndex: '',
        };
    },
    computed: {},
    watch: {},
    methods: {
        openGoodsSelect(field) {
            this.$refs['showSelectData'].openBox('businessGoodsList', field, 'bgmId')
        },
        changeTime(val) {
            if (val) {
                this.getRequestData.end = val + 24 * 60 * 60 * 1000 - 1
            }
        },
        changeFormEndTime(val) {
            if (val) {
                const dayStart = new Date(new Date(val).toLocaleDateString()).getTime()
                this.sendDataInfo.promEndate = dayStart + 24 * 60 * 60 * 1000 - 1
            }
        },
        isShowData(name, value) {
            switch (name) {
                case 'prodGiftid': {
                    const info = sessionStorage.getItem('selectBusinessGoodsEntryInfo')
                    if (info) {
                        const infoTwo = JSON.parse(info)
                        this.sendSonDataInfo.prodGiftName = infoTwo.bgmName
                    }
                    this.sendSonDataInfo[name] = value
                    break
                }
                case 'prodSaleid': {
                    const info = sessionStorage.getItem('selectBusinessGoodsEntryInfo')
                    if (info) {
                        const infoTwo = JSON.parse(info)
                        this.sendSonDataInfo.prodSaleName = infoTwo.bgmName
                    }
                    this.sendSonDataInfo[name] = value
                    break
                }
                default:
                    this.sendSonDataInfo[name] = value
            }
        },
        getSelectedMainData() {
            const dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({ message: '请先选中要操作的数据', type: 'error' })
                return null
            }
            return dataInfo
        },
        getSelectedDetailData() {
            if (this.selectedDetailsDataIndex === '') {
                this.$message({ message: '请先选中要操作的促销商品', type: 'error' })
                return null
            }
            const selectInfo = this.selectedDetailsDataIndex.split(',').map(Number)
            const mainRow = this.returnData.list[this.selectedDataIndex]
            const dataInfo = mainRow && mainRow.promotiondetailInfos ? mainRow.promotiondetailInfos[selectInfo[1]] : null
            if (!dataInfo) {
                this.$message({ message: '暂无选择数据', type: 'error' })
                return null
            }
            return dataInfo
        },
        getDataDateils() {
            const dataInfo = this.getSelectedMainData()
            if (!dataInfo) {
                return false
            }
            for (let key in this.sendDataInfo) {
                if (Object.prototype.hasOwnProperty.call(dataInfo, key)) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
            }
            return true
        },
        initActionBox() {
            this.sendDataInfo = {
                pmState: 0,
                promEndate: '',
                promName: '',
                promRemark: '',
                promStdate: '',
            }
            this.dataActionBox.actionType = 0
            this.dataActionBox.showStatus = false
        },
        initSonActionBox() {
            this.sendSonDataInfo = {
                prodGiftid: '',
                prodGiftName: '',
                prodGiftnum: 0,
                prodIsaccum: 0,
                prodSaleid: '',
                prodSaleName: '',
                prodSalenum: 0,
                prodState: 0,
                promId: '',
                prodId: '',
            }
            this.sonDataActionBox.actionType = 0
            this.sonDataActionBox.showStatus = false
        },
        openActionBox(cate) {
            this.initActionBox()
            if (cate == 0) {
                this.dataActionBox.boxTitle = '新增促销策略'
                this.dataActionBox.openMode = 'rtl'
            } else {
                this.dataActionBox.boxTitle = '编辑促销策略'
                this.dataActionBox.openMode = 'rtl'
                if (this.getDataDateils() == false) {
                    return false
                }
            }
            this.dataActionBox.actionType = cate
            this.dataActionBox.showStatus = true
        },
        selectedDataAction() {
            this.selectedDetailsDataIndex = ''
        },
        selectedDetailsDataAction(data) {
            const info = String(data).split(',').map(Number)
            this.selectedDataIndex = info[0]
        },
        openSonDataBox(cate, dataId) {
            this.initSonActionBox()
            this.sendSonDataInfo.promId = dataId
            if (cate == 0) {
                this.sonDataActionBox.boxTitle = '新增促销商品'
                this.sonDataActionBox.openMode = 'ltr'
            } else {
                const dataInfo = this.getSelectedDetailData()
                if (!dataInfo) {
                    return false
                }
                const giftGood = dataInfo.giftGoodInfo || {}
                const saleGood = dataInfo.saleGoodInfo || {}
                this.sendSonDataInfo.prodGiftid = giftGood.bgmId || ''
                this.sendSonDataInfo.prodGiftName = giftGood.bgmName || ''
                this.sendSonDataInfo.prodGiftnum = dataInfo.prodGiftnum
                this.sendSonDataInfo.prodSaleid = saleGood.bgmId || ''
                this.sendSonDataInfo.prodSaleName = saleGood.bgmName || ''
                this.sendSonDataInfo.prodSalenum = dataInfo.prodSalenum
                this.sendSonDataInfo.prodIsaccum = dataInfo.prodIsaccum
                this.sendSonDataInfo.prodState = dataInfo.prodState
                this.sendSonDataInfo.prodId = dataInfo.prodId
                this.sonDataActionBox.boxTitle = '编辑促销商品'
                this.sonDataActionBox.openMode = 'rtl'
            }
            this.sonDataActionBox.actionType = cate
            this.sonDataActionBox.showStatus = true
        },
        async sendDetailsDataAction() {
            if (!this.sendSonDataInfo.prodSaleid) {
                this.$message({ message: '请选择商品', type: 'error' })
                return false
            }
            if (this.sendSonDataInfo.prodSalenum === '' || this.sendSonDataInfo.prodSalenum === null || this.sendSonDataInfo.prodSalenum < 0) {
                this.$message({ message: '请填写商品数量', type: 'error' })
                return false
            }
            if (!this.sendSonDataInfo.prodGiftid) {
                this.$message({ message: '请选择赠品', type: 'error' })
                return false
            }
            if (this.sendSonDataInfo.prodGiftnum === '' || this.sendSonDataInfo.prodGiftnum === null || this.sendSonDataInfo.prodGiftnum < 0) {
                this.$message({ message: '请填写赠品数量', type: 'error' })
                return false
            }
            this.submitLoading = true
            try {
                let responseData
                if (this.sonDataActionBox.actionType == 0) {
                    responseData = await this.$http.addPromotionStrategyDetails(this.sendSonDataInfo)
                } else {
                    responseData = await this.$http.setPromotionStrategyDetails(this.sendSonDataInfo)
                }
                if (responseData.status == 200) {
                    this.$message({ message: '操作成功', type: 'success' })
                    this.sonDataActionBox.showStatus = false
                    this.getDataList()
                } else {
                    this.$message({ message: responseData.message, type: 'error' })
                }
            } finally {
                this.submitLoading = false
            }
        },
        async sendDataAction() {
            if (this.sendDataInfo.promName == '') {
                this.$message({ message: '请填写方案名称', type: 'error' })
                return false
            }
            if (!this.sendDataInfo.promStdate) {
                this.$message({ message: '请选择开始时间', type: 'error' })
                return false
            }
            if (!this.sendDataInfo.promEndate) {
                this.$message({ message: '请选择结束时间', type: 'error' })
                return false
            }
            if (this.sendDataInfo.promStdate > this.sendDataInfo.promEndate) {
                this.$message({ message: '开始时间不能大于结束时间', type: 'error' })
                return false
            }
            this.submitLoading = true
            try {
                let responseData
                if (this.dataActionBox.actionType == 0) {
                    responseData = await this.$http.addPromotionStrategy(this.sendDataInfo)
                } else {
                    const sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
                    sendData.promId = this.returnData.list[this.selectedDataIndex].promId
                    responseData = await this.$http.setPromotionStrategy(sendData)
                }
                if (responseData.status == 200) {
                    const isAdd = this.dataActionBox.actionType == 0
                    this.initActionBox()
                    this.$message({ message: '操作成功', type: 'success' })
                    if (isAdd) {
                        this.setDataPageNumber(1)
                    } else {
                        this.getDataList()
                    }
                } else {
                    this.$message({ message: responseData.message, type: 'error' })
                }
            } finally {
                this.submitLoading = false
            }
        },
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                case 1:
                    this.openActionBox(actionData.actionType)
                    break
                case 2:
                    this.delDataAction()
                    break
            }
        },
        searchData() {
            if (this.getRequestData.start && this.getRequestData.end && this.getRequestData.start > this.getRequestData.end) {
                this.$message({ message: '开始时间不能大于结束时间', type: 'error' })
                return
            }
            this.getRequestData.page = 1
            this.getDataList()
        },
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },
        async getDataList() {
            this.tableLoading = true
            try {
                const responseData = await this.$http.getPromotionStrategy(this.getRequestData)
                if (responseData.status == 200) {
                    this.returnData.list = responseData.result.list || []
                    this.returnData.pages = responseData.result.pages
                    this.returnData.total = responseData.result.total
                    this.returnData.pageNum = responseData.result.pageNum
                    this.selectedDataIndex = 0
                    this.selectedDetailsDataIndex = ''
                } else {
                    this.$message({ message: responseData.message, type: 'error' })
                }
            } finally {
                this.tableLoading = false
            }
        },
        delDetails() {
            const dataInfo = this.getSelectedDetailData()
            if (!dataInfo) {
                return false
            }
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const delData = { ids: [dataInfo.prodId] }
                const responseData = await this.$http.delPromotionStrategyDetails(delData)
                if (responseData.status == 200) {
                    this.$message({ type: 'success', message: '删除成功!' })
                    this.getDataList()
                } else {
                    this.$message({ message: responseData.message, type: 'error' })
                }
            }).catch(() => { })
        },
        delDataAction() {
            const dataInfo = this.getSelectedMainData()
            if (!dataInfo) {
                return false
            }
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const delData = { ids: [dataInfo.promId] }
                const responseData = await this.$http.delPromotionStrategy(delData)
                if (responseData.status == 200) {
                    this.$message({ type: 'success', message: '删除成功!' })
                    this.getDataList()
                } else {
                    this.$message({ message: responseData.message, type: 'error' })
                }
            }).catch(() => { })
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
    },
    created() {
        this.getDataList()
        this.getButtonList()
    },
    mounted() { },
    updated() {
        this.tableHeight = this.$common.getTableHeight()
    },
}
</script>

<style scoped>
.dis {
    display: flex;
    flex-wrap: wrap !important;
}

.page_content_top_line {
    padding-bottom: 0;
}

/* 对齐 v-tabs / 报表工具栏主题 */
.module_toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 3px solid #e4e7ed;
    padding: 0 10px;
    min-height: 36px;
}

.module_toolbar_left {
    display: flex;
    align-items: center;
}

.report_name {
    font-size: 14px;
    color: #409eff;
    font-weight: 500;
    padding: 5px 0;
    border-bottom: 2px solid #409eff;
    margin-bottom: -2px;
}

.module_count {
    font-size: 12px;
    color: #909399;
}

.module_block {
    margin: 4px 0;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 2px;
}

.module_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    padding: 6px 12px;
}

.module_title {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    position: relative;
    padding-left: 10px;
}

.module_title::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 14px;
    background-color: #409eff;
    border-radius: 1px;
}

.module_body {
    padding: 10px 12px;
}

.detail_toolbar {
    margin-bottom: 8px;
}

.form_tip {
    margin-top: 6px;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
}

.form_tip i {
    margin-right: 4px;
    color: #909399;
}

/* 抽屉主题 */
.drawer_panel {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
}

.drawer_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
}

.drawer_title {
    font-size: 15px;
    font-weight: 500;
    color: #303133;
    position: relative;
    padding-left: 10px;
}

.drawer_title::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 14px;
    background-color: #409eff;
    border-radius: 1px;
}

.drawer_close {
    font-size: 16px;
    color: #909399;
    cursor: pointer;
}

.drawer_close:hover {
    color: #409eff;
}

.drawer_body {
    flex: 1;
    overflow-y: auto;
    padding: 20px 24px 10px;
}

.drawer_foots {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 12px 16px;
    border-top: 1px solid #e4e7ed;
    background: #fff;
}
</style>
